// extracted by mini-css-extract-plugin
export default {"main":"BlockHeader_main__HwTHo","name":"BlockHeader_name__CC-Vg","anim":"BlockHeader_anim__k47hl","arrow":"BlockHeader_arrow__Aoy7C"};